(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.web.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.web.holding :refer [overview-card]]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [herb.core :refer [<class]]
  
   [frontend.ui.component.table.view :as table]))


(defn company-section
  [new-investment-ui-data props]
  (let [{:keys [holding-name overview-new ownership-new image-1 logo-image-1]} new-investment-ui-data]
    [section/portfolio-section
     [:div
      [:div
       {:style {:display     :flex
                :justify-content :space-between
                :align-items :flex-end
                :gap         :16px}}
       [:div
        {:style {:display   :inline-flex
                 :max-width :200px}}
        (when (and (not (:edit-mode? props)) (cu/blank-value? (:image logo-image-1)))
          [:div {:class (<class style/holding-header)} holding-name])
        [image/image (if (cu/blank-value? (:image logo-image-1)) "Add company logo" "") logo-image-1 props true]]
       [:div
        {:style {:padding-top :16px}}
        [badge/badge
         {:variant :new-investment
          :pill?   false}
         "New investment"]]]]

     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card overview-new props]
      [grid/row {}
       [grid/column {:large 6}
        [image/image (if (cu/blank-value? (:image image-1)) "Add image" "") image-1 props false]]
       [grid/column {:large 6}
        [table/editable-table ownership-new props
         [horizontal-table/table "Ownership" ownership-new props]]]]]]))

(defn new-investment
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])
